import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en';
import ptTranslation from './locales/pt';

// PT é sempre o padrão. Só iniciamos em inglês quando o usuário
// escolheu EN explicitamente (mesma regra do LanguageContext),
// evitando que um valor antigo em localStorage "grude" o site em inglês.
const hasLocalStorage = typeof localStorage !== 'undefined';
const savedLanguage = hasLocalStorage ? localStorage.getItem('language') : null;
const userSetLanguage = hasLocalStorage ? localStorage.getItem('language_user_set') : null;
const initialLanguage = savedLanguage === 'en' && userSetLanguage === 'true' ? 'en' : 'pt';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      pt: { translation: ptTranslation },
    },
    lng: initialLanguage,
    fallbackLng: 'pt',
    interpolation: { escapeValue: false },
  });

export default i18n;